import { c as _c } from "react/compiler-runtime";
import { Chats, Images, SummaryTable, ImagesWithDepartments, ChatsWithDepartments } from "@shared-components/core-metrics";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";
type SummaryChatsAndImagesProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};
export const SummaryChatsAndImages = props => {
  const $ = _c(21);
  let t0;
  if ($[0] !== props.endDate || $[1] !== props.startDate) {
    t0 = <SummaryTable startDate={props.startDate} endDate={props.endDate} />;
    $[0] = props.endDate;
    $[1] = props.startDate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  if ($[3] !== props.endDate || $[4] !== props.granularity || $[5] !== props.startDate) {
    t1 = <Chats startDate={props.startDate} endDate={props.endDate} granularity={props.granularity} />;
    t2 = <Images startDate={props.startDate} endDate={props.endDate} granularity={props.granularity} />;
    $[3] = props.endDate;
    $[4] = props.granularity;
    $[5] = props.startDate;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <hr />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex row gap-3 items-center mt-3"><h2 className="mb-4">{"Departments categorization"}</h2></div>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  let t6;
  if ($[10] !== props.endDate || $[11] !== props.granularity || $[12] !== props.startDate) {
    t5 = <ChatsWithDepartments startDate={props.startDate} endDate={props.endDate} granularity={props.granularity} />;
    t6 = <ImagesWithDepartments startDate={props.startDate} endDate={props.endDate} granularity={props.granularity} />;
    $[10] = props.endDate;
    $[11] = props.granularity;
    $[12] = props.startDate;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t0 || $[16] !== t1 || $[17] !== t2 || $[18] !== t5 || $[19] !== t6) {
    t7 = <>{t0}{t1}{t2}{t3}{t4}{t5}{t6}</>;
    $[15] = t0;
    $[16] = t1;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};